export const TOKEN_ID = 'token';
export const SELECTED_WORSHIP_PLACE_TOKEN = 'SELECTED_WORSHIP_PLACE';
